import React from 'react';
import { useSortBy } from 'react-instantsearch';
import { ArrowUpDown } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface SortOption {
  value: string;
  label: string;
}

interface SortByProps {
  items: SortOption[];
  className?: string;
}

export const SortBy: React.FC<SortByProps> = ({ items, className = '' }) => {
  const { currentRefinement, refine } = useSortBy({
    items: items.map(item => ({
      value: item.value,
      label: item.label,
    })),
  });

  const currentLabel = items.find(item => item.value === currentRefinement)?.label || 'Sort by';

  return (
    <Select value={currentRefinement} onValueChange={refine}>
      <SelectTrigger className={`w-48 ${className}`}>
        <ArrowUpDown className="h-4 w-4 mr-2" />
        <SelectValue placeholder={currentLabel} />
      </SelectTrigger>
      <SelectContent>
        {items.map(item => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};